import React from 'react'

const Deatails = () => {
  return (
    <div>Deatails</div>
  )
}

export default Deatails